// extracted by mini-css-extract-plugin
export default {"page":"xF2WRcGaCg9Q3biIR0Qy__page___"};